// extracted by mini-css-extract-plugin
module.exports = {"customSelection":"CustomSelection_customSelection__2-6D0","customSelectionInput":"CustomSelection_customSelectionInput__30h2b"};